<template>
  <router-view ref="child"></router-view>
</template>
<script>
export default {
  name: 'EmptyPageView',
  methods: {
    onTableRowClick (record) {
      let that = this.$refs.child
      return {
        on: {
          click: (event) => {
            if (event.target.tagName !== 'svg' && event.target.tagName !== 'path') {
              let rowKeyValue = that.$refs.TableInfo.rowKey(record)
              let _index = that.selectedRowKeys.indexOf(rowKeyValue)
              if (_index === -1) {
                that.selectedRowKeys.push(rowKeyValue)
              } else {
                let selectedRowKeys = []
                that.selectedRowKeys.forEach((item, index) => {
                  if (index !== _index) {
                    selectedRowKeys.push(item)
                  }
                })
                that.onSelectChange(selectedRowKeys)
              }
            }
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// EmptyPageView.vue?7cd97f32